(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/symbols/assets/javascripts/shared.js') >= 0) return;  svs.modules.push('/components/ui/symbols/assets/javascripts/shared.js'); "use strict";


var svs = svs || {};

(function (svs) {
  'use strict';

  svs.ui = svs.ui || {};
  svs.ui.symbols = svs.ui.symbols || {};
  var isServerSide = typeof exports === 'object',
      config;

  if (isServerSide) {
    const trinidad = require('trinidad-core').core;

    config = trinidad.config;
  } else {
    config = {
      options: svs.core.config.data.svsconfig
    };
  }

  const path = '/images/ui/symbols/',
        cdn = config.options && config.options.cdn ? config.options.cdn : '',
        hashedSvgs = {
    '18-logo-neg': '18-logo-neg-33526ed55249d451a0a4b44297a350f85ef723b2.svg',
    '18-logo-neg-18': '18-logo-neg-33526ed55249d451a0a4b44297a350f85ef723b2.svg',
    '18-logo-pos': '18-logo-pos-2f26304fc9ba44ee3ff26d123208f5175655f80b.svg',
    '18-logo-pos-18': '18-logo-pos-2f26304fc9ba44ee3ff26d123208f5175655f80b.svg',
    'sok-header': 'sok-header-03941c64c26005e236b6a8cb55a8051bb118ff81.svg',
    'svenskaspel-os': 'svenskaspel-os-fa6b28226e32eb419f4e9d9e6e8a1ee6c9283281.svg'
  };

  svs.ui.symbols.getSVG = function (svg, size, inline) {
    let hashedStr = svg;

    if (hashedSvgs[hashedStr] && size > 0) {
      hashedStr = hashedSvgs[hashedStr + '-' + size] ? hashedStr + '-' + size : hashedStr;
    }

    if (inline) {
      const request = new XMLHttpRequest();
      request.open('GET', cdn + path + hashedSvgs[hashedStr], false);
      request.send(null);

      if (request.status === 200) {
        return request.responseText;
      }
    } else {
      return hashedSvgs[hashedStr] ? cdn + path + hashedSvgs[hashedStr] : false;
    }
  }; 


  if (typeof exports === 'object') {
    module.exports = svs.ui.symbols;
  }
})(svs);
 })(window);